import React, { useEffect, useState, useRef, useCallback } from "react";
import "../css/paysuccess.scss";
import { useNavigate, useSearchParams } from "react-router-dom";
// import { successPay } from "../apis/SuccessAPI";
import { PixelWithEvent } from "./common/PixelWithEvent ";
import * as FacebookAPI from "../apis/FacebookAPI";
import { sendMessage } from "../apis/SendMessageAPI";
import { sendEmailToClient } from "../apis/SendEmail";
import { BASE_URL, LIST_URL } from "../constans/ApiEndpointConstants";
import * as GetPixelAPI from "../apis/GetPixelAPI";
import { getOrder } from "../apis/GetOrder";
import { getDetails } from "../apis/GetDetails";
import { getFullDonationUrl, parseDonationUrl } from "../utils/urlUtils";
import Cookie from "react-cookies";
import Cookies from "js-cookie";
import LocalStorageUtil from "../utils/localStorageUtil";

const PaySuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const ad = LocalStorageUtil.getAd() || "donation";
  // eslint-disable-next-line no-unused-vars
  const [orderDetails, setOrderDetails] = useState(null);
  const [shareCount, setShareCount] = useState(0);
  const [progress, setProgress] = useState(0);
  const [msgHidden, setMsgHidden] = useState(true);
  const [returnMsg, setReturnMsg] = useState("");
  // 使用 useRef 防止在 StrictMode 下重复调用 successcallback
  const hasProcessedPurchase = useRef(false);
  const orderNo = searchParams.get("clientNo");
  const emailOrderNumber = searchParams.get("orderNo");
  const redirectStatus = searchParams.get("redirect_status");
  const isRedirectSucceeded =
    redirectStatus === null ? true : redirectStatus === "succeeded";
  let email = searchParams.get("email") || "";
  let phone = searchParams.get("phone") || "";
  const [campaignDetails, setCampaignDetails] = useState(null);
  const emailSentKey = `successEmailSent_${orderNo}`;
  const [successPixelData, setSuccessPixelData] = useState();
  const detailPathParam = searchParams.get("detailPath") || null;
  const detailPathDecoded = detailPathParam
    ? decodeURIComponent(detailPathParam)
    : null;
  // 用于解析 id 的纯路径（去掉 detailPath 中的 query 部分，避免 id 带上 ?email=...）
  const detailPathForId = detailPathDecoded
    ? detailPathDecoded.split("?")[0]
    : null;
  const detailId =
    searchParams.get("detailId") ||
    (detailPathForId ? parseDonationUrl(detailPathForId) : "") ||
    "";

  // 如果 detailPath 中包含嵌入的查询参数（例如 "/donationDetails/test_17?email=...?phone=..."）
  // 则从中解析 email 和 phone（仅当它们未在 top-level query 中提供时覆盖）
  if (detailPathDecoded) {
    const qIndex = detailPathDecoded.indexOf("?");
    if (qIndex !== -1) {
      const queryString = detailPathDecoded.slice(qIndex + 1);
      // 支持用 ? 或 & 分隔的非标准或标准格式
      queryString.split(/[?&]/).forEach((pair) => {
        if (!pair) return;
        const [rawKey, rawVal] = pair.split("=");
        if (!rawKey || rawVal === undefined) return;
        const key = decodeURIComponent(rawKey).toLowerCase();
        const val = decodeURIComponent(rawVal);
        if (!email && key === "email") {
          email = val;
        }
        if (!phone && key === "phone") {
          phone = val;
        }
      });
    }
  }

  console.log(email);
  console.log(phone);
  console.log(detailPathDecoded);
  console.log(detailId);
  console.log(detailPathParam);

  //event_id，要去重，一天之内用一个，存cookie
  const getEventId = (eventType) => {
    // 根据事件类型使用不同的cookie名
    const cookieName = `fb_event_id_${eventType}`;

    let storedEventId = Cookies.get(cookieName);
    if (storedEventId) {
      return storedEventId;
    } else {
      // 使用 10 位随机数字作为 event_id
      const newEventId = Math.round(Math.random() * 10000000000).toString();
      Cookies.set(cookieName, newEventId, { expires: 1 }); // 存储1天
      return newEventId;
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // 分享功能
  const campaignUrl = campaignDetails
    ? getFullDonationUrl(campaignDetails, BASE_URL)
    : detailPathDecoded
    ? `${BASE_URL.replace(/\/$/, "")}${
        detailPathDecoded.startsWith("/") ? "" : "/"
      }${detailPathDecoded}`
    : `${BASE_URL.replace(/\/$/, "")}/donationDetails/${detailId}`;
  const campaignUrlWithAd = `${campaignUrl}?ad=share`;

  // 分享文案：优先使用 detailsData.share_text（如果存在），否则回退到默认文案
  const defaultShareText =
    "こんにちは！現在支援を受け付けている重要なプロジェクトを共有させていただきます。少額の寄付でもプロジェクトを前進させる力になります。また、このメッセージをシェアしていただくだけでも大きな支援となります。温かいご支援をお願いいたします。";

  const invitationTextRaw = campaignDetails?.share_text || defaultShareText;

  // 将常见的智能引号替换为普通引号，避免 URL 编码后显示异常
  const invitationText = invitationTextRaw
    .replace(/'/g, "'") // 替换右单引号
    .replace(/'/g, "'") // 替换左单引号
    .replace(/"/g, '"') // 替换左双引号
    .replace(/"/g, '"'); // 替换右双引号
  const encodedCampaignUrl = encodeURIComponent(campaignUrlWithAd);
  const encodedInvitation = encodeURIComponent(
    `${invitationText}\n\n${campaignUrlWithAd}`
  );

  const shareOptions = [
    {
      id: "facebook",
      name: "Facebook",
      icon: "/svg-jp/f1-1.svg",
      color: "#1877F2",
      url: `https://www.facebook.com/dialog/share?app_id=407682420960&display=popup&href=${encodedCampaignUrl}`,
    },
    {
      id: "x",
      name: "X",
      icon: "/svg-jp/f1-2.svg",
      color: "#000000",
      url: `https://twitter.com/intent/post?text=${encodedInvitation}&url=${encodedCampaignUrl}`,
    },
    {
      id: "line",
      name: "LINE",
      icon: "/svg-jp/f1-3.svg",
      color: "#00C300",
      url: `https://social-plugins.line.me/lineit/share?url=${encodedCampaignUrl}`,
    },
    {
      id: "note",
      name: "note",
      icon: "/svg-jp/f1-4.svg",
      color: "#000000",
      url: `https://note.com/share?url=${encodedCampaignUrl}`,
    },
  ];

  // 随机生成六位字符（包含数字和字母）
  const generateRandomCode = () => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < 6; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters[randomIndex];
    }
    return result;
  };

  // 获取或生成 userid
  let userid = localStorage.getItem("userid");
  if (!userid) {
    userid = generateRandomCode();
    localStorage.setItem("userid", userid);
  }

  // 从 getpixel 接口获取模板 ID 等配置，然后调用fetchCampaignDetails方法获取像素等配置
  useEffect(() => {
    try {
      const strippedUrl = BASE_URL.replace(/^https?:\/\//, "");
      GetPixelAPI.getpixel(strippedUrl)
        .then((res) => {
          const pixelData = res?.data?.data || {};

          setSuccessPixelData(pixelData);

          // 获取 detailId：优先从 pixelData 中获取，如果没有则从 URL 参数获取
          const detailIdFromPixel = pixelData?.donationID;
          const detailIdFromUrl = searchParams.get("detailId");
          const finalDetailId = detailIdFromPixel || detailIdFromUrl;

          // 调用获取 campaign details 的方法
          if (finalDetailId) {
            fetchCampaignDetails(finalDetailId);
          }
        })
        .catch((error) => {
          console.error("Failed to fetch templateId from getpixel", error);
        });
    } catch (error) {
      console.error("Failed to init templateId from getpixel", error);
    }
  }, []);

  // 从 pixel 配置中提取成功邮件模板 ID
  const successEmailTemplateId = successPixelData?.successEmailId;

  //从接口获取orderDetails（依赖 successEmailTemplateId，确保模板已就绪）
  const getOrderRes = async () => {
    if (!orderNo) return;

    try {
      const res = await getOrder(orderNo);

      const order = res.data.data.data;
      const parsedOrder = JSON.parse(order);

      setOrderDetails(parsedOrder);

      if (isRedirectSucceeded) {
        successcallback(parsedOrder);

        // 如果已经发送过成功邮件，则不再重复发送
        const alreadySent = localStorage.getItem(emailSentKey) === "true";

        if (!alreadySent) {
          try {
            await sendEmailToClient(
              successEmailTemplateId,
              "{name},{Ordernumber},{Amount}",
              `${parsedOrder.firstName} ${parsedOrder.lastName},${emailOrderNumber},${parsedOrder.amount}`,
              "{name}",
              `${parsedOrder.firstName} ${parsedOrder.lastName}`,
              email
            );

            sendMessage(
              `${BASE_URL}-[成功支付邮件发送成功]:id=${detailId}:ad=${ad}:userid=${userid}:email=${email}`
            );
            localStorage.setItem(emailSentKey, "true");
          } catch (err) {
            console.error("发送成功邮件失败:", err);
            sendMessage(
              `${BASE_URL}-[成功支付邮件发送失败]:id=${detailId}:${
                err?.message || err
              }`
            );
          }
        }
      }
    } catch (error) {
      console.error("获取订单信息失败:", error);
    }
  };

  // 处理支付成功回调（等 successEmailTemplateId 到位后再拉订单 + 发成功邮件）
  useEffect(() => {
    // 使用 localStorage 跟踪是否已为当前订单发送过消息
    if (orderNo && isRedirectSucceeded && successEmailTemplateId) {
      const messageSentKey = `successPayMessageSent_${orderNo}`;
      const hasSentMessage = localStorage.getItem(messageSentKey);

      if (!hasSentMessage) {
        sendMessage(
          BASE_URL + `[ Success Pay]:id=${detailId}:ad=${ad}:userid=${userid}  `
        );
        // 标记已发送，避免刷新时重复发送
        localStorage.setItem(messageSentKey, "true");
      }

      getOrderRes();
    }
  }, [orderNo, isRedirectSucceeded, successEmailTemplateId]);

  // 当 campaignDetails 获取到后，如果之前跳过了 successcallback，现在重新执行
  useEffect(() => {
    if (campaignDetails && orderDetails && !hasProcessedPurchase.current) {
      // 检查是否已经处理过购买事件
      const flag = Cookie.load("purchased");
      if (!flag) {
        successcallback(orderDetails);
      }
    }
  }, [campaignDetails, orderDetails]);

  // 初始化分享进度
  useEffect(() => {
    const savedCount = localStorage.getItem("shareCount");
    const savedProgress = localStorage.getItem("progress");

    if (savedCount) {
      setShareCount(parseInt(savedCount, 10));
    }

    if (savedProgress) {
      const parsedProgress = parseInt(savedProgress, 10);
      setProgress(parsedProgress);

      // 如果 progress 已经是 100，则自动显示第三条 returnMsg
      if (parsedProgress === 100) {
        setReturnMsg(
          "シェアありがとうございます！あなたの支援が、このプロジェクトをより多くの人に届ける力になります。"
        );
      }
    }
  }, []);

  // facebookApi
  const successcallback = (orderDetail) => {
    // 防止在 StrictMode 下重复调用
    if (hasProcessedPurchase.current) {
      return;
    }

    let flag = Cookie.load("purchased");

    // 如果 flag 不存在，或者订单号不一样，则继续执行
    if (!flag) {
      // 检查 campaignDetails 是否已获取，如果没有则延迟执行
      if (!campaignDetails) {
        console.log("campaignDetails not ready, skipping Facebook API calls");
        return;
      }

      // 标记为已处理，防止重复调用
      hasProcessedPurchase.current = true;
      const event_id = getEventId("Purchase");

      const eventData = {
        value: orderDetail.amount,
        content_ids: ["donation"],
        content_name: "Success Donation",
        content_type: "product",
        contents: [
          {
            id: "donation",
            title: "Donation",
            quantity: 1,
          },
        ],
        currency: "jpy",
        num_items: 1,
      };

      let userdata = {
        em: orderDetail.email,
        ph: orderDetail.phone,
        fn: orderDetail.firstName,
        ln: orderDetail.lastName,
        ct: orderDetail.city,
        st: orderDetail.state,
        zp: orderDetail.zipCode,
        country: orderDetail.country,
      };

      PixelWithEvent("Purchase", event_id);
      PixelWithEvent("Donate", event_id);

      FacebookAPI.Facebook(
        campaignDetails?.fbq_token,
        campaignDetails?.pixel,
        event_id,
        "Purchase",
        eventData,
        userdata
      )
        .then((res) => {
          sendMessage(
            BASE_URL + `[Purchase]:id=${detailId}:ad=${ad}:userid=${userid}  `
          );

          sendMessage(
            `purchase eventsAll---${JSON.stringify(res)}:id=${detailId}`
          );
          localStorage.removeItem("orderDetail");
          const now = new Date();
          now.setMonth(now.getMonth() + 1); // 设置为当前时间 + 1 个月

          // 保存 purchased flag 和订单号到 cookie
          Cookie.save("purchased", "purchased", {
            expires: now,
            path: "/",
          });
        })
        .catch((err) => {
          console.error("Failed to send event", err);
          // 如果失败，重置标记以便重试
          hasProcessedPurchase.current = false;
        });

      FacebookAPI.Facebook(
        campaignDetails?.fbq_token,
        campaignDetails?.pixel,
        event_id,
        "Donate",
        eventData,
        userdata
      );
    }
  };

  const backToProduct = () => {
    navigate("/");
  };

  const handleShareOptionClick = (option) => {
    if (!option.url) {
      return;
    }

    handleShareClick(option.name);

    if (option.sameTab) {
      window.location.href = option.url;
      return;
    }

    window.open(option.url, option.target || "_blank", "noopener,noreferrer");
  };

  // 处理分享操作
  const handleShareClick = (platformName = "") => {
    // 发送分享消息
    sendMessage(
      BASE_URL +
        `[Success Share]:id=${detailId}:ad=${ad}:userid=${userid}:platform=${platformName}  `
    );

    let newShareCount = shareCount + 1;
    let newProgress = progress;

    if (newShareCount !== 3 && newShareCount !== 5) {
      newProgress = Math.min(newProgress + 20, 100);
    }

    setShareCount(newShareCount);
    setProgress(newProgress);

    //将分享次数和进度条进度存在本地缓存
    localStorage.setItem("shareCount", newShareCount);

    // 延迟更新进度条
    setTimeout(() => {
      setProgress(newProgress);
      localStorage.setItem("progress", newProgress);
    }, 800); // 800ms 延迟更新进度条

    setMsgHidden(false);

    // 延迟显示不同的消息
    setTimeout(() => {
      if (newShareCount === 3) {
        setReturnMsg(
          "別の友達にもシェアしましょう。同じ友達へのシェアはカウントされません。"
        );
      } else if (newShareCount === 5) {
        setReturnMsg("グループへのシェアも可能です。");
      } else if (newShareCount >= 7) {
        setReturnMsg(
          "シェアありがとうございます！あなたの支援が、このプロジェクトをより多くの人に届ける力になります。"
        );
      } else {
        setReturnMsg("");
      }
    }, 800); // 800ms 延迟显示消息
  };

  // 给图片加上前缀
  const resolveUrl = (raw) => {
    if (!raw) return "";
    if (/^https?:\/\//i.test(raw) || raw.startsWith("data:")) return raw;
    return `${LIST_URL.replace(/\/$/, "")}/${String(raw).replace(/^\//, "")}`;
  };

  // 获取 campaignDetails 的方法，用于分享与成功页展示
  const fetchCampaignDetails = useCallback(async (id) => {
    if (!id) return;

    try {
      const res = await getDetails(id);
      // 后端返回结构可能为 res.data 或 res.data.data，尽量兼容
      const payload = res?.data;

      setCampaignDetails(payload);
    } catch (err) {
      console.error("Failed to fetch campaign details in SuccessPay:", err);
    }
  }, []);

  // 如果 URL 中携带 detailPath（编码后的 /donationDetails/Name_id），优先从中解析 id 并获取 campaignDetails
  useEffect(() => {
    const pidFromPath = detailPathForId
      ? parseDonationUrl(detailPathForId)
      : null;
    const pid = detailId || pidFromPath;
    if (pid && !campaignDetails) {
      fetchCampaignDetails(pid);
    }
  }, [detailId, detailPathForId, campaignDetails, fetchCampaignDetails]);

  return (
    <>
      {/* top */}
      <div className="product_box_top success_product_box_top">
        <div
          className="product_box_top_left"
          onClick={backToProduct}
          style={{ cursor: "pointer" }}
        >
          <svg
            t={1763633148216}
            className="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id={2746}
            width={200}
            height={200}
          >
            <path
              d="M297.813333 491.648l1.365334-1.749333 379.093333-376.149334a38.784 38.784 0 0 1 5.077333-4.096 34.346667 34.346667 0 0 1 14.293334-4.992c2.218667-0.170667 2.176-0.170667 4.394666-0.170666a33.493333 33.493333 0 0 1 14.549334 4.181333c12.330667 6.997333 18.688 21.76 15.274666 35.498667-1.237333 5.077333-7.04 13.44-7.04 13.44l-355.498666 352.853333 354.090666 354.389333s6.272 7.978667 7.893334 12.928a32.213333 32.213333 0 0 1-33.749334 41.557334c-6.656-0.682667-17.749333-7.68-17.749333-7.68l-379.221333-377.984-1.28-1.450667a30.378667 30.378667 0 0 1-7.893334-17.749333 31.018667 31.018667 0 0 1 3.712-18.602667 27.221333 27.221333 0 0 1 2.688-4.224z"
              p-id={2747}
            />
          </svg>
        </div>
        <div className="logo_container">
          <img
            src={process.env.PUBLIC_URL + "/head/main-jp.png"}
            alt="gyo"
            className="gyo_logo"
            style={{ height: "24px" }}
          />
        </div>
        <div className="tw-w-1/3" />
      </div>
      {/* main */}
      <div className="success_box">
        <img
          alt="Donation Successful"
          src={resolveUrl(
            campaignDetails?.image?.[0]?.url || orderDetails?.successLogo
          )}
          className="success_box_img"
        />
        <div className="success_box_txt1">
          ご支援ありがとうございます。
          <br />
          あなたの寄付は、この取り組みを前進させる大きな力となります。
          <br />
          まもなく寄付完了の確認メール（
          <span className="success_box_txt1_span">{email}</span>）またはSMS（
          <span className="success_box_txt1_span">{phone}</span>
          ）が届きます。
        </div>

        {/* Share Section */}
        <div className=" success_pay_share">
          {shareOptions.map((option) => (
            <button
              key={option.id}
              className="icon-btn"
              onClick={() => handleShareOptionClick(option)}
            >
              <div className={`icon-circle ${option.id}`}>
                {typeof option.icon === "string" ? (
                  <img alt="" src={option.icon} />
                ) : (
                  option.icon
                )}
              </div>
              {option.name}
            </button>
          ))}
        </div>
        {progress > 0 && (
          <div className="quick-share-modal__progress-section quick-share-modal__progress-section-success">
            <div className="quick-share-modal__progress-header">
              <span>シェア状況</span>
              <span>{progress}%</span>
            </div>

            <div className="quick-share-modal__progress-bar">
              <div
                className="quick-share-modal__progress-fill"
                style={{ width: `${progress}%` }}
              ></div>
            </div>

            <p className="quick-share-modal__share-count">
              {shareCount}回シェアされました
            </p>
            {!msgHidden && returnMsg && (
              <p className="quick-share-modal__return-msg">{returnMsg}</p>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default PaySuccess;
